import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TranslationContext } from '../../../../assets/contexts/translationContext';
import { cancelDepositFlow, clearDepositSession, getDepositSession } from '../../../../assets/services/deposit';
import CardPage from '../../../CardPages/CardPage/CardPage';
import ScreenHeader from '../../../ScreenHeader/ScreenHeader';
import BottomActionButton from '../../../shared/BottomActionButton/BottomActionButton';
import DepositOperations from '../DepositOperations/DepositOperations';
import './DepositSuccess.css';

function DepositSuccess() {
  const navigate = useNavigate();
  const { common, deposit, t } = useContext(TranslationContext);
  const [session] = useState(() => getDepositSession());
  const operations = Array.isArray(session?.operations) ? session.operations : [];
  const returnPath = session?.returnPath || '/home';
  const safeReturnPath = typeof returnPath === 'string' && returnPath && !returnPath.startsWith('/deposit')
    ? returnPath
    : '/home';

  useEffect(() => {
    if (session?.status !== 'success') {
      navigate('/deposit', { replace: true });
    }
  }, [navigate, session?.status]);

  const handleDone = () => {
    cancelDepositFlow();
    clearDepositSession();
    if (window.history.state?.idx > 0) {
      navigate(-1);
      return;
    }

    navigate(safeReturnPath, { replace: true });
  };

  return (
    <CardPage className="deposit-success">
      <div className="deposit-success__content">
        <ScreenHeader title={deposit.topUpCard} onBack={handleDone} />

        <div className="deposit-success__hero">
          <div className="deposit-success__icon" aria-hidden="true">
            <svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.11461e-05 10.3427L3.04262 7.26172L9.24291 13.3597L22.6534 0.000354528L25.7216 3.08132L9.24291 19.4961L1.11461e-05 10.3427Z" fill="currentColor" />
            </svg>
          </div>

          <h2 className="deposit-success__title">{deposit.topUpReceived}</h2>
          <p className="deposit-success__subtitle">
            {t('deposit.addedToBalance', { amount: session?.amountUsd ?? '$0.00' })}
          </p>
        </div>

        <DepositOperations operations={operations} showEmpty={false} />
      </div>

      <BottomActionButton className="deposit-success__done" onClick={handleDone}>
        {common.done}
      </BottomActionButton>
    </CardPage>
  );
}

export default DepositSuccess;
